import { withSentryReactRouterV7Routing } from "@sentry/react";
import { Routes, Route } from "react-router-dom";
import { StudentApp } from "./views/student_app";
import { Dashboard, DashboardStart } from "./views/dashboard";

const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export default function App() {
  return (
    <SentryRoutes>
      <Route path="/dashboard" element={<DashboardStart />} />
      <Route path="/dashboard/:code" element={<Dashboard />} />
      <Route path="/*" element={<StudentApp />} />
    </SentryRoutes>
  );
}
